import { isValid } from 'date-fns';
import { dateHandle } from '../date';

export const dateValidator = (value: string) => {
  return dateHandle({
    value,
    failure: () => false,
    success: isValid,
  });
};
